import React, { useState, useEffect } from "react";
import "./style.css";
import Pageloader from "../../../components/loader";
import {Table, Button, Input, Typography, Space, Tooltip} from "antd";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";
import { dataKey } from "../../../utils/Helpers";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import NotesDeleteModal from "./deleteModal";
import * as dispatcherNotesActions from "../../../redux/actions/dispactherNote.actions";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
const { Text, Title } = Typography;
const { Search } = Input;


const DispatcherNotesList = (props) => {
  const pagename = "Dispatcher Note";
  const navigate = useNavigate();
  const [noteListItems, setNoteListItems] = useState(null);
  const [loading, setLoading] = useState(false);
 
  useEffect(() => {
    dispacthNoteList()
  }, [])

  const dispacthNoteList = async () => {
    try {
      setLoading(true);
      await props.dispatcherNotesActions.dispactherNoteListAction();
    } catch (e) {} finally {
      setLoading(false);
    }
  }
  
  useEffect(() => {
    if (props.dispactherNoteData){
      setNoteListItems(dataKey(props.dispactherNoteData))
    }
  }, [props.dispactherNoteData])

  const columns = [
    {
      title: 'Id',
      dataIndex: 'display_id',
    },
    {
      title: 'Note',
      dataIndex: 'value',
    },
    {
      title: 'Created At',
      dataIndex: 'created_at',
      render: (value)=>{return <><span>{moment(value).format("DD MMMM, yyyy")}</span><p>{moment(value).format("h:mm A")}</p></>},
    },
    {
      title: 'Updated At',
      dataIndex: 'updated_at',
      render: (value)=>{return <><span>{moment(value).format("DD MMMM, yyyy")}</span><p>{moment(value).format("h:mm A")}</p></>},
    },
    {
      title: 'Action',
      render: (value)=>{
      return <Space>
        <Tooltip title="Edit">
          <EditOutlined onClick={() => navigate(`/dispatchernote/add/${value.id}`)} />
        </Tooltip>
        <Tooltip title="Delete">
          <DeleteOutlined onClick={() => handleModalOpen(value.id, value.display_id, value.value)} />
        </Tooltip>
      </Space>},
    },
  ]

  const [notesModal, setNotesModal] = useState({
    visible: false,
    postid: null,
    displayid: null,
    value: null,
  });

  const handleModalOpen = (id, dId, val) => {
    setNotesModal((notesModal) => ({
      ...notesModal,
      visible: true,
      postid: id,
      displayid: dId,
      value: val,
    }));
  };
  const handleModalCancel = () => {
    setNotesModal((notesModal) => ({
      ...notesModal,
      visible: false,
      postid: null,
      displayid: null,
      value: null,
    }));
  };

  return (
    <div className="page-content">
      <NotesDeleteModal
        handlevisible={notesModal.visible}
        handleCancel={handleModalCancel}
        refreshData={dispacthNoteList}
        postdata={notesModal}
      />
      <div className="page-content-header">
        <Title level={2}>{pagename}s Management</Title>
        <div>
          <Button onClick={() => navigate("/dispatchernote/add")}>{pagename} Add</Button>
        </div>
      </div>
      {loading ? (
        <Pageloader />
      ) : (
        <Table dataSource={noteListItems} columns={columns} />
      )}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    dispactherNoteData: state.DispactherNoteReducer.dispactherNoteData,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    dispatcherNotesActions: bindActionCreators(dispatcherNotesActions, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(DispatcherNotesList);
